import { render, staticRenderFns } from "./Pixels.vue?vue&type=template&id=6fb4bb22&scoped=true&"
import script from "./Pixels.vue?vue&type=script&lang=ts&"
export * from "./Pixels.vue?vue&type=script&lang=ts&"
import style0 from "./Pixels.vue?vue&type=style&index=0&id=6fb4bb22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4bb22",
  null
  
)

export default component.exports